<template>
    <Loader style="z-index:10000" v-if="loader" />  
    <div class="mb-2">
      <Accordion>
        <AccordionTab header="Carica Accettazioni">
          <div class="formgrid grid form-file">
            <div class="field col-12 md:col-8">
              <div class="text-center allowed-format"> Formati consentiti: {{ Object.keys(allowedType).join(', ') }} </div>
              <div class="button-wrapper">
                <span :class="['label', { 'active': fileToUpload.length > 0 }]">
                  {{ fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
                </span>
                
                <input id="upload" type="file" ref="file" :key="keyInputReset" @change="handleFileUpload($event)"
                  :accept="`${Object.values(allowedType).join(', ')}`" />
              </div>
              <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
              <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
            </div>
            <div class="col-12 lg:col-2">
              <label>Tipo fornitura</label>
              <Dropdown v-model="selectedTypeFornituraForUpload" :options="switchinCaricati.type" optionLabel="name"
                optionValue="name" class="inputfield w-full" />
            </div>
            <div class="field col-12 md:col-2 flex align-items-end pb-2">
              <Button @click="uploadFile" icon="pi pi-upload" />
              <Button @click="reloadAccettazioniProgress" icon="pi pi-refresh" class="p-button-outlined btn-accettazioni-progress" title="Stato elaborazione" />
            </div>
          </div>
          <div class="text-400">
            <small>*No intestazioni; Colonna A: n.protocollo (vuoto o testo alfanumerico da 15 caratteri che inizia con SII); Colonna B: fornitura; Colonna C: da annullare (vuoto o SI); Colonna D: note (vuoto o testo)</small>
          </div>
        </AccordionTab>
      </Accordion>
      <div v-if="fileAccettazioni.length" class="mt-2">
        <div v-for="file in fileAccettazioni" :key="file.file_id + '-' + file.status">
          <small>
            <b>{{ accettazioniStatusLabel[file.status] || file.status }}</b>
            — {{ file.file_name }}
            ({{ file.type }})
            — {{ file.processed }} / {{ file.total }} righe
          </small>
        </div>
      </div>
    </div>
    <!-- <div class="card mt-2">
      <div class="grid">
        <div class="sw-caricati field col-12 md:col-3">
          <label>Tipo fornitura</label>
          <Dropdown v-model="switchinCaricati.selected_type" :options="switchinCaricati.type" optionLabel="name"
            optionValue="name" class="inputfield w-full" />
        </div>
        <div class="field col-12 md:col-3">
          <label>Tipo switch</label>
          <Dropdown v-model="selectedTypeSwitch" :options="switchSelectedOptions" optionLabel="label" optionValue="value"
            class="inputfield w-full" />
        </div>
        <div class="field col-12 md:col-3">
          <label>Data decorrenza</label>
          <Calendar v-model="switchinCaricati.data_decorrenza" :showIcon="true" :manualInput="false" dateFormat="dd-mm-yy"
            class="inputfield w-full" />
        </div>
  
        <div class="field col-12 md:col-3 ">
          <Button @click="searchDataSwCaricati" icon="pi pi-search" class="p-button-primary w-full" label="Cerca"
            style=" margin-left: 8px; margin-top: 22px;" />
        </div>
  
      </div>
      <div>
        <div v-if="switchinCaricati.items.some(el => el.id == null)">
          <Message severity="error">
            Attenzione ci sono
            {{ switchinCaricati.items.filter(el => el.id == null).reduce(acc => acc + 1, 0) }}
            fornitura/e NON presenti in ask
          </Message>
        </div>
      </div>
      <div class="m-2 flex justify-content-end">
        <p class="text-600"><b>{{ switchinCaricati.items.length }} elementi</b></p>
      </div>
      <div>
        <DataTable ref="dt" :value="switchinCaricati.items" tableStyle="width: 100%" dataKey="id"
          responsiveLayout="scroll" :rowClass="rowClass" v-model:filters="filters" filterDisplay="row"
          :paginator="true" :rows="30" stripedRows>
          
          <Column field="id" header="#id" :sortable="true" class="header-column" />
          <Column field="code" header="Code" :sortable="true" class="header-column">
            <template #body="{ data }">
              <span v-if="data.id > 0">
                <p class="text-primary cursor-pointer"
                  @click="window.open(`/ask/${data.code.startsWith('IT') ? 'pods' : 'pdrs'}/${data.id}/dettagli`, '_blank')">
                  {{ data.code }}
                </p>
              </span>
              <span v-else>
                {{ data.code }}
              </span>
            </template>
          </Column>
          <Column field="data_inizio" header="Data Inizio" :sortable="true" class="header-column">
            <template #body="{ data }">
              {{ data.data_inizio != null ? formatDate(data.data_inizio) : '' }}
            </template>
          </Column>
          <Column field="data_fine" header="Data Fine" :sortable="true" class="header-column">
            <template #body="{ data }">
              {{ data.data_fine != null ? formatDate(data.data_fine) : '' }}
            </template>
          </Column>
          <Column field="cliente" header="Cliente" :sortable="true" class="header-column" />
          <Column header="Rappresentante" filterField="rappresentante" :showFilterMenu="false"
            :filterMenuStyle="{ width: '14rem' }" class="header-column">
            <template #body="{ data }">
              <div class="flex align-items-center gap-2">
                <span>{{ data.rappresentante }}</span>
              </div>
            </template>
          </Column>
          <Column header="Agente" filterField="agente" :showFilterMenu="false" :filterMenuStyle="{ width: '14rem' }"
            class="header-column">
            <template #body="{ data }">
              <div class="flex align-items-center gap-2">
                <span>{{ data.agente }}</span>
              </div>
            </template>
          </Column>
          <Column header="Udd" filterField="udd" :showFilterMenu="false" :filterMenuStyle="{ width: '14rem' }"
            class="header-column">
            <template #body="{ data }">
              <div class="flex align-items-center gap-2">
                <span>{{ data.udd }}</span>
              </div>
            </template>
          </Column>
          <Column header="Stato Fornitura" filterField="stato_internal_pratica" :showFilterMenu="false"
            :filterMenuStyle="{ width: '14rem' }" class="header-column">
            <template #body="{ data }">
              <div class="flex align-items-center gap-2">
                <span>{{ data.stato_internal_pratica }}</span>
              </div>
            </template>
          </Column>
          <Column header="Stato Matrice" filterField="stato_matrice" :showFilterMenu="false"
            :filterMenuStyle="{ width: '14rem' }" class="header-column">
            <template #body="{ data }">
              <div class="flex align-items-center gap-2">
                <span>{{ data.stato_matrice }}</span>
              </div>
            </template>
          </Column>
          <Column field="note" header="Note" :sortable="true" class="header-column" />
          <Column field="is_new" header="Nuovo" class="header-column" />
        </DataTable>
      </div>
    </div> -->
  </template>
  
  <script>
  import { FilterMatchMode } from "primevue/api";
  import Service from "@/services/ask-pratiche/pratiche-service";
  import { ref, computed, getCurrentInstance, } from "vue";
  import Loader from "@/components/Loader.vue";
  import { useToast } from "primevue/usetoast";
  import moment from "moment";
  import { useConfirm } from "primevue/useconfirm";
  
  export default {
    components: {
      Loader,
    },
    setup() {
      const dt = ref();
      const toast = useToast();
      const loader = ref(false);
      const filters = ref({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        agente: { value: null, matchMode: FilterMatchMode.IN },
        rappresentante: { value: null, matchMode: FilterMatchMode.IN },
        stato_matrice: { value: null, matchMode: FilterMatchMode.IN },
        stato_internal_pratica: { value: null, matchMode: FilterMatchMode.IN },
        udd: { value: null, matchMode: FilterMatchMode.IN },
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus;
      self.$http = self.appContext.config.globalProperties.$http;
      const formatDate = self.appContext.config.globalProperties.$formatDate;
      const service = new Service(self.$eventBus);
      const dialogSwitchinCaricati = ref(false)
      const switchinCaricati = ref({
        'type': [
          { name: "pod" },
          { name: "pdr" },
        ],
        'selected_type': 'pod',
        'data_decorrenza': moment().add(1, 'months').startOf('month').toDate(),
        'items': []
      })
      const selectedTypeFornituraForUpload = ref(switchinCaricati.value.type[0].name);
      const agents = ref([])
      const representatives = ref([])
      const matrice_states = ref([])
      const internal_states = ref([])
      const udds = ref([])
      const keyInputReset = ref(0)
      const fileToUpload = ref([])
      const allowedType = {
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
      const validationErrors = ref({})
      const submitted = ref(false)
      const accettazioniProgress = ref(null)
      const accettazioniStatusLabel = {
        in_elaborazione: 'In elaborazione',
        completato: 'Completato',
        errore: 'Errore',
        in_coda: 'In coda',
        interrotto: 'Interrotto',
      }
      const fileAccettazioni = computed(() => {
        const data = accettazioniProgress.value
        if (!data) return []
        const current = data.current
        const queue = Array.isArray(data.queue) ? data.queue : []
        const rows = queue.map((file) => {
          if (!current || Number(file.file_id) !== Number(current.file_id)) return file
          return {
            ...file,
            processed: current.processed ?? file.processed,
            total: current.total ?? file.total,
            status: current.status || file.status,
          }
        })
        if (current && current.file_id != null && !rows.some((file) => Number(file.file_id) === Number(current.file_id))) {
          rows.unshift({
            file_id: current.file_id,
            file_name: current.file_name,
            type: current.type,
            processed: current.processed,
            total: current.total,
            status: current.status,
          })
        }
        const attivi = rows
          .filter((file) => file.status !== 'completato')
          .sort((a, b) => Number(a.file_id) - Number(b.file_id))
        const ultimoCompletato = rows
          .filter((file) => file.status === 'completato')
          .sort((a, b) => Number(b.file_id) - Number(a.file_id))[0]
        return ultimoCompletato ? [ultimoCompletato, ...attivi] : attivi
      })
  
      const isDeleteButtonVisible = ref(false);
      const confirm = useConfirm();
  
      const selectedTypeSwitch = ref(1);
      const switchSelectedOptions = ref([
        { label: 'Nuova fornitura', value: 1 },
        { label: 'Switch tecnici', value: 0 },
        { label: 'Tutto', value: 2 },
      ]);
  
      const handleFileUpload = async (evt) => {
        evt.preventDefault()
        fileToUpload.value = []
        submitted.value = false;
        fileToUpload.value = self.refs.file.files
      }
  
      const reloadAccettazioniProgress = () => {
        return loadAccettazioniProgress()
      }

      const loadAccettazioniProgress = () => {
        return service.getAccettazioniCronProgress()
          .then((res) => {
            accettazioniProgress.value = res?.data ?? null
          })
      }

      loadAccettazioniProgress()

      const uploadFile = () => {
        submitted.value = true
        if (validateFiles()) {
          loader.value = true;
          service.uploadFileSwitchOk(fileToUpload.value, selectedTypeFornituraForUpload.value)
          .then((res) => {
            let data = res.res.data
            let status = res.res.status

            let severity
            let summary
            let detail = data.message
            switch (status) {
              case 200:
                if (data.success) {
                  severity = 'success'
                  summary = 'Successo'
                } else {
                  severity = 'warn'
                  summary = 'Attenzione'                
                }

                fileToUpload.value = []
                toast.add({severity:severity, summary: summary, detail:detail})
                if (data.success) {
                  return loadAccettazioniProgress()
                }
                break;
              default:
                severity = 'error'
                summary = 'Errore'

                break;
            }

            toast.add({severity:severity, summary: summary, detail:detail})
          }).finally(() => {
            keyInputReset.value = new Date()
            loader.value = false;
          })
        }
      }
  
      const searchDataSwCaricati = () => {
        loader.value = true;
        switchinCaricati.value.items = []
  
        // service.getPdpSwitchCaricatiCache(
        //   switchinCaricati.value.selected_type,
        //   moment(switchinCaricati.value.data_decorrenza).format('YYYY-MM-DD'),
        //   selectedTypeSwitch.value
        // ).then((res) => {
        //   console.log(res.data);
        // });
  
        service.getPdpSwitchCaricatiCache(
          switchinCaricati.value.selected_type,
          moment(switchinCaricati.value.data_decorrenza).format('YYYY-MM-DD'),
          selectedTypeSwitch.value
        )
          .then((res) => {
            console.log(res);
            let response = res.data;
            if (response.length > 0) {
              isDeleteButtonVisible.value = true;
            } else {
              isDeleteButtonVisible.value = false;
            }
            switchinCaricati.value.items = response
  
            switchinCaricati.value.items.forEach(el => {
              el.id = el[`${switchinCaricati.value.selected_type}_id`];
            })
            switchinCaricati.value.items.forEach(el => {
              if (!agents.value.some(e => e.name == el.agente)) {
                agents.value.push({ name: el.agente });
              }
              if (!representatives.value.some(e => e.name == el.rappresentante)) {
                representatives.value.push({ name: el.rappresentante });
              }
              if (!matrice_states.value.some(e => e.name == el.stato_matrice)) {
                matrice_states.value.push({ name: el.stato_matrice });
              }
              if (!internal_states.value.some(e => e.name == el.stato_internal_pratica)) {
                internal_states.value.push({ name: el.stato_internal_pratica });
              }
              if (!udds.value.some(e => e.name == el.udd)) {
                udds.value.push({ name: el.udd });
              }
            });
          })
          .finally(() => {
            loader.value = false;
          });
      }
  
      const validateFiles = () => {
  
        if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
        } else {
          delete validationErrors.value['files'];
        }
  
        if (fileToUpload.value.length > 0) {
          let valid = [...fileToUpload.value].every(file => [Object.values(allowedType).join(', ')].includes(file.type), false);
          if (valid)
            delete validationErrors.value['type'];
          else
            validationErrors.value['type'] = true;
        }
  
        return !Object.keys(validationErrors.value).length;
      }
  
  
      const eliminaRecords = () => {
        console.log('Elimina records');
  
        let data_decorrenza = moment(switchinCaricati.value.data_decorrenza).format('YYYY-MM-DD');
        console.log('Data decorrenza', data_decorrenza);
        service.deleteSwithInByDataDecorrenza(data_decorrenza)
          .then(res => {
            console.log('risposta: ', res);
            switchinCaricati.value.items = [];
            toast.add({ severity: 'success', summary: 'Successo', detail: `Record eliminati correttamente` });
            loader.value = false;
          });
      };
  
      const showConfirmDialog = () => {
        confirm.require({
          message: 'Vuoi eliminare tutti i record?',
          header: 'Conferma',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            eliminaRecords();
            loader.value = true;
          },
          reject: () => {
            console.log('Operazione annullata');
          }
        });
      }
  
      const exportCSV = () => {
        dt.value.exportCSV()
      };
  
      const rowClass = (data) => {
        return data.id == null ? 'bg-pink-100' : ''
      };
  
      return {
        window,
        dt,
        loader,
        formatDate,
        filters,
        selectedTypeFornituraForUpload,
        selectedTypeSwitch,
        switchSelectedOptions,
        fileToUpload,
        allowedType,
        submitted,
        dialogSwitchinCaricati,
        switchinCaricati,
        searchDataSwCaricati,
        agents,
        representatives,
        matrice_states,
        internal_states,
        udds,
        validationErrors,
        keyInputReset,
        handleFileUpload,
        uploadFile,
        reloadAccettazioniProgress,
        accettazioniProgress,
        accettazioniStatusLabel,
        fileAccettazioni,
        rowClass,
        exportCSV,
        eliminaRecords,
        isDeleteButtonVisible,
        showConfirmDialog,
        // moment
      };
    },
  };
  </script>
  <style>
  .switchin-calc .p-datatable-thead {
    display: none;
  }
  
  .switchin-calc .pi-bars {
    cursor: move;
  }
  
  .fornitura-switchin .p-dropdown-label {
    text-transform: uppercase !important;
  }
  
  .sw-caricati .p-dropdown-label,
  .p-dropdown-items .p-dropdown-item {
    text-transform: uppercase !important;
  }
  </style>
  
  <style scoped>
  .p-dropdown-items .p-dropdown-item {
    text-transform: uppercase !important;
  }
  
  .btn-accettazioni-progress {
    margin-left: 16px;
  }

  .form-file .button-wrapper {
    position: relative;
    width: 100%;
    text-align: center;
  }
  
  .form-file .allowed-format {
    font-size: 12px;
    color: rgb(186, 186, 186);
    margin-top: 2px;
  }
  
  .form-file .button-wrapper span.label {
    position: relative;
    z-index: 0;
    display: inline-block;
    width: 100%;
    background: #ffffff;
    border: 1px solid rgb(217, 217, 217) !important;
    cursor: pointer;
    color: rgb(168, 168, 168);
    padding: 10px 2px;
    text-transform: uppercase;
    font-size: 12px;
    border-radius: 3px;
  }
  
  .form-file .button-wrapper span.label.active {
    background: #2196F3;
    color: white;
  }
  
  .form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }
  
  .box-wrapper .box {
    cursor: pointer;
  }
  
  .box-wrapper .box .card {
    background-color: #f4f4f4;
    padding-bottom: 8px;
  }
  
  .box-wrapper .highlight .card {
    /* background: rgba(66, 244, 17, 0.195); */
    border-bottom: 6px solid rgb(18, 158, 251);
    background-color: #fff;
  }
  
  .produzione label {
    font-size: 13px;
  }
  </style>
  